import ListItemLoading from "@/components/loading/listItemLoading/listItemLoading";
import { useGetMerchantServices } from "@/services/appointment/hooks/useGetMerchantServices";
import useScheduleStore from "@/store/schedule";
import {
  Button,
  Card,
  Checkbox,
  Divider,
  Group,
  ScrollArea,
  Stack,
  Text,
} from "@mantine/core";
import { IconFilter } from "@tabler/icons-react";
import { useState } from "react";

type Props = {
  close: () => void;
};

function FilterMerchantService({ close }: Props) {
  const { setMerchantServiceFilters } = useScheduleStore();

  const { data, isLoading } = useGetMerchantServices();
  const [values, setValues] = useState<string[]>([]);
  const submit = () => {
    const services = data?.filter(({ id }) =>
      values.map((x) => +x).includes(id || 0)
    );
    setMerchantServiceFilters({
      merchantServiceFilters: services,
    });
    close();
  };

  return isLoading ? (
    <ListItemLoading count={3} />
  ) : (
    <Stack h="360px">
      <Divider label="خدمات" labelPosition="center" />
      <ScrollArea mih={270}>
        <Checkbox.Group value={values} onChange={setValues}>
          <Stack gap="xs">
            {data?.map((item) => (
              <Card
                p="0"
                withBorder
                key={item?.id}
                w="100%"
                styles={{
                  root: {
                    width: "100%",
                    minWidth: "100%",
                  },
                }}
              >
                <Checkbox
                  radius="md"
                  value={item?.id?.toString()}
                  key={item?.id}
                  p="md"
                  styles={{
                    label: {
                      width: "100%",

                      flex: 1,
                    },
                  }}
                  label={
                    <Group gap="xs" w="100%">
                      {/* <IconCircleFilled color={item?.color || ""} size={10} /> */}
                      <Text size="xs">{item?.title}</Text>
                    </Group>
                  }
                />
              </Card>
            ))}
          </Stack>
        </Checkbox.Group>
      </ScrollArea>
      <Button size="md" h={120} onClick={submit}>
        <Group gap="xs">
          <IconFilter stroke={1.5} size={20} />
          <Text>فیلتر</Text>
        </Group>
      </Button>
    </Stack>
  );
}

export default FilterMerchantService;
